import { env } from 'next-runtime-env';

import { FadeInImage } from '~shared/ui/atoms';

import { Button, Container, Inside, Shadow, StyledLink, Title } from './styles';

type Props = {
	title: string;
	url: string;
	href?: string;
	imageWidth: number;
	imageHeight: number;
	onClick?: () => void;
};

export const ImageCard = ({
	title,
	url,
	href,
	imageWidth,
	imageHeight,
	onClick,
}: Props) => {
	const inner = (
		<>
			<Title>{title}</Title>
		</>
	);

	const src = url && `${env('NEXT_PUBLIC_PUBLIC_API') ?? ''}${url}`;

	return (
		<Container>
			{src && (
				<FadeInImage
					className="imageCover"
					src={src}
					width={imageWidth}
					height={imageHeight}
					quality={100}
					alt=""
				/>
			)}
			<Shadow />
			<Inside>
				{href ? (
					<StyledLink href={href}>{inner}</StyledLink>
				) : (
					<Button type="button" onClick={onClick}>
						{inner}
					</Button>
				)}
			</Inside>
		</Container>
	);
};
